export const PortfolioList = [
  {
    id: 7,
    title: "Módulo de Pagamentos",
    img: "/imgs/payments.png",
    listImgs: [
      { id: 1, item: "/imgs/payments.png" },
      { id: 1, item: "/imgs/payments-2.webp" },
    ],
    listVideos: [],
    link: "https://github.com/mstarkRules",
    description:
      "Funcionalidade que integra uma aplicação ao sistema da GalaxPay, plataforma de pagamentos. O módulo implementado permite visualizar as faturas pagas e pendentes dos clientes cadastrados na aplicação, além de permitir a emissão dos boletos. Além disso a aplicação só permitia a visualização do conteúdo dessa tela caso o usuário que tentasse acessá-la preenchesse os requisitos estabelecidos pelo cliente, caso contrário, indicava uma tela de contatos para que ele se adequasse as regras de acesso.",
  },

  {
    id: 3,
    title: "Aplicação Web Letmeask",
    img: "/imgs/letmeask.png",
    listImgs: [{ id: 1, item: "/imgs/letmeask.png" }],
    listVideos: [],
    link: "https://letmeask-8c2a3.web.app/",
    description:
      "Aplicação Web que cria salas de perguntas pra produtores de conteúdo online. Projeto feito durante a trilha de ReactJS da NLW, evento da Rocketseat",
  },
  {
    id: 2,
    title: "Museu Virtual Laurimar Leal",
    img: "/imgs/mv-amazonia.webp",
    listImgs: [
      { id: 1, item: "/imgs/mv-amazonia.webp" },
      { id: 1, item: "/imgs/mv-amazonia-2.webp" },
    ],
    listVideos: [],
    link: "https://museudaamazonialaurimarleal.com",
    description: "Acervo virtual de obras do artista amazônico Laurimar Leal.",
  },
  {
    id: 1,
    title: "Front-end Max Transportes",
    img: "/imgs/max-frontend-screen.png",
    listImgs: [{ id: 1, item: "/imgs/max-frontend-screen.png" }],
    listVideos: [],
    link: "https://github.com/mstarkRules",
    description:
      "Frontend inicial do Max App, uma aplicação de entrega, feita com ReactJS.",
  },
  {
    id: 8,
    title: "Módulo Agendador de Bloqueios",
    img: "/imgs/lockout-scheduler.png",
    listImgs: [
      { id: 1, item: "/imgs/lockout-scheduler.png" },
      { id: 1, item: "/imgs/lockout-scheduler-2.png" },
    ],
    listVideos: [],
    link: "https://github.com/mstarkRules",
    description:
      "Funcionalidade que permite agendar comandos de bloqueios/desbloqueios para múltiplos rastreadores de frotas de veículos.",
  },

  {
    id: 4,
    title: "Projeto Dt-Money - Ignite",
    img: "/imgs/dt-money-screen.png",
    listImgs: [{ id: 1, item: "/imgs/dt-money-screen.png" }],
    listVideos: [],
    link: "https://github.com/mstarkRules/02-dt-money",
    description:
      "Projeto Dt-Money, uma aplicação web para gerenciar entradas e saídas. Projeto feito seguindo a trilha de ReactJS, do Ignite.",
  },
  {
    id: 9,
    title: "Landing Page World Engenharia",
    img: "/imgs/w-engenharia.png",
    listImgs: [
      { id: 1, item: "/imgs/w-engenharia.png" },
      { id: 1, item: "/imgs/w-engenharia-2.png" },
    ],
    listVideos: [],
    link: "https://worldengenharia.com.br/",
    description: "Landing Page de uma empresa de engenharia elétrica.",
  },

  {
    id: 5,
    title: "Projeto Rocketshoes",
    img: "/imgs/rocketshoes.png",
    listImgs: [{ id: 1, item: "/imgs/rocketshoes.png" }],
    listVideos: [],
    link: "https://github.com/mstarkRules/ignite-chapter2-challenge-hook-scart",
    description:
      "Projeto de uma listagem de itens de uma loja de sapatos. Permite inserir e remover itens do carrinho. Projeto feito seguindo a trilha de ReactJS, do Ignite.",
  },

  {
    id: 6,
    title: "Aplicativo Móvel Meus Trabalhos",
    img: "/imgs/meus-trabalhos.jpg",
    listImgs: [{ id: 1, item: "/imgs/meus-trabalhos.jpg" }],
    listVideos: [],
    link: "https://github.com/mstarkRules/meustrabalhos",
    description:
      "Aplicação móvel feita para o meu Trabalho de Conclusão do Curso de Sistemas de Informação. O aplicativo funciona como uma agenda eletrônicas de atividades escolares, e permite adicionar trabalhos e calcular notas automaticamente.",
  },
];
